import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { MarvelChampionsComponent } from './marvel-champions.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BoardGameComponent } from './views/board-game/board-game.component';
import { RoomSelectComponent } from './views/room-select/room-select.component';
import { RoomCreationComponent } from './views/room-creation/room-creation.component';
import { AboutComponent } from './views/about/about.component';

const routes: Routes = [
  // keyforge
  /* {
    path: '', // mc
    component: MarvelChampionsComponent
  }, */
  {
    path: '', // mc
    component: RoomSelectComponent
  },
  {
    path: 'room',
    component: RoomSelectComponent
  },
  {
    path: 'room-creation/:roomCreationId',
    component: RoomCreationComponent
  },
  {
    path: 'play/:roomId', // mc/play/-M3xECwYK6ml8ewQT4o5
    component: BoardGameComponent
  },
  {
    path: 'about',
    component: AboutComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), ReactiveFormsModule],
  exports: [RouterModule]
})
export class MarvelChampionsRoutingModule {}
